import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import '../../styles/core.scss';
import css from './index.scss';


let id = 0;
function createRows(sectionId, name, yearGroups) {
    id += 1;
    const grades = yearGroups.join(', ');
    return { id, sectionId, name, grades };
}

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: 14,
        fontFamily: 'poppins'
    },
    body: {
        fontSize: 14,
        fontFamily: 'poppins'
    }
}))(TableCell);

const SectionList = ({ handleOnSectionNameClick, sections }) => {
    const rows = sections.map(section => createRows(section.id, section.name, section.yearGroups));

    return (
        <div className={css.sectionListComponent}>

            <Paper className={css.root}>
                <Table className={css.table}>
                    <colgroup>
                        <col width="30%" />
                        <col width="30%" />
                        <col width="20%" />
                        <col width="20%" />
                    </colgroup>
                    <TableHead>
                        <TableRow>
                            <CustomTableCell>Section Id</CustomTableCell>
                            <CustomTableCell align="left">Section name</CustomTableCell>
                            <CustomTableCell align="left">Year Groups</CustomTableCell>
                            <CustomTableCell align="center">Pending changes?</CustomTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map(row => (
                            <TableRow key={row.id}>
                                <CustomTableCell component="th" scope="row">
                                    {row.sectionId}
                                </CustomTableCell>
                                <CustomTableCell align="left"><a href={`/section-detail/${row.sectionId}`} onClick={e => handleOnSectionNameClick(e, row.sectionId)}>{row.name}</a></CustomTableCell>
                                <CustomTableCell align="left">{row.grades}</CustomTableCell>
                                <CustomTableCell align="center">?</CustomTableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </div>);
};

SectionList.propTypes = {
    sections: PropTypes.array,
    handleOnSectionNameClick: PropTypes.func
};

export default styleable(css)(SectionList);



// WEBPACK FOOTER //
// ./app/components/section-list/index.js